"use strict";
/*
 * Created on 4. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Statistics for price zones.
 * @author Radek Beran
 */


var PriceZoneStats =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceZoneStats, _DomainObject_1$Domai);

  function PriceZoneStats(priceZoneId, sitesCount) {
    var _this;

    _classCallCheck(this, PriceZoneStats);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneStats).call(this));
    _this.priceZoneId = priceZoneId;
    _this.sitesCount = sitesCount;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price zone statistics.
   */


  _createClass(PriceZoneStats, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceZoneStats(mat.priceZoneId, mat.sitesCount);
    }
  }]);

  return PriceZoneStats;
}(DomainObject_1.DomainObject);

exports.PriceZoneStats = PriceZoneStats;

PriceZoneStats.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceZoneStats.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    sitesCount: builder.num('sitesCount')
  };
}();